/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_PendingInputs */

const en_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pending`)
};

const id_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ditunda`)
};

const ms_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`belum selesai`)
};

const ca_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pendent`)
};

const cs_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pending`)
};

const da_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`afventer`)
};

const de_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ausstehend`)
};

const et_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ootel`)
};

const es_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pendiente`)
};

const fr_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en attente`)
};

const hr_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`na čekanju`)
};

const it_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in sospeso`)
};

const lv_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gaida`)
};

const lt_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`laukiama patvirtinimo`)
};

const hu_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`függőben`)
};

const nl_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in behandeling`)
};

const nb_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`venter`)
};

const pl_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oczekiwanie`)
};

const pt_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pendente`)
};

const ro_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`în așteptare`)
};

const sk_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nespracované`)
};

const sl_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`poteka`)
};

const fi_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`odottaa`)
};

const sv_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`väntar`)
};

const vi_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đang chờ xử lý`)
};

const tr_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beklemede`)
};

const el_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`σε εκκρεμότητα`)
};

const bg_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`в изчакване`)
};

const ru_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pending`)
};

const sr_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`на чекању`)
};

const uk_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`очікується`)
};

const ka_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მომლოდინე`)
};

const hi_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विलंबित`)
};

const th_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รอดำเนินการ`)
};

const ko_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보류 중`)
};

const zh_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待处理`)
};

const zh_tw_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待中`)
};

const ja_status_pending = /** @type {(inputs: Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保留中`)
};

/**
* | output |
* | --- |
* | "pending" |
*
* @param {Status_PendingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const status_pending = /** @type {((inputs?: Status_PendingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_PendingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_status_pending(inputs)
	if (locale === "ms") return ms_status_pending(inputs)
	if (locale === "ca") return ca_status_pending(inputs)
	if (locale === "cs") return cs_status_pending(inputs)
	if (locale === "da") return da_status_pending(inputs)
	if (locale === "de") return de_status_pending(inputs)
	if (locale === "et") return et_status_pending(inputs)
	if (locale === "es") return es_status_pending(inputs)
	if (locale === "fr") return fr_status_pending(inputs)
	if (locale === "hr") return hr_status_pending(inputs)
	if (locale === "it") return it_status_pending(inputs)
	if (locale === "lv") return lv_status_pending(inputs)
	if (locale === "lt") return lt_status_pending(inputs)
	if (locale === "hu") return hu_status_pending(inputs)
	if (locale === "nl") return nl_status_pending(inputs)
	if (locale === "nb") return nb_status_pending(inputs)
	if (locale === "pl") return pl_status_pending(inputs)
	if (locale === "pt") return pt_status_pending(inputs)
	if (locale === "ro") return ro_status_pending(inputs)
	if (locale === "sk") return sk_status_pending(inputs)
	if (locale === "sl") return sl_status_pending(inputs)
	if (locale === "fi") return fi_status_pending(inputs)
	if (locale === "sv") return sv_status_pending(inputs)
	if (locale === "vi") return vi_status_pending(inputs)
	if (locale === "tr") return tr_status_pending(inputs)
	if (locale === "el") return el_status_pending(inputs)
	if (locale === "bg") return bg_status_pending(inputs)
	if (locale === "ru") return ru_status_pending(inputs)
	if (locale === "sr") return sr_status_pending(inputs)
	if (locale === "uk") return uk_status_pending(inputs)
	if (locale === "ka") return ka_status_pending(inputs)
	if (locale === "hi") return hi_status_pending(inputs)
	if (locale === "th") return th_status_pending(inputs)
	if (locale === "ko") return ko_status_pending(inputs)
	if (locale === "zh") return zh_status_pending(inputs)
	if (locale === "zh-tw") return zh_tw_status_pending(inputs)
	if (locale === "ja") return ja_status_pending(inputs)
	return en_status_pending(inputs)
});